<template>
  <!--门户界面-->
  <div class="container-layout">
    <div class="register-context">
      <div class="register-container">
        <div class="register-context-left"></div>
        <div class="register-context-right">
          <el-form
            ref="registerForm"
            :model="registerForm"
            :rules="registerRules"
            autocomplete="on"
            style="margin-top: 10px"
          >
            <!-- <div class="register-title">
          <el-row>
            <font style="color: white; font-size: 18px">用户注册</font>
            <font style="color: red; font-size: 15px">
              *仅面向货主用户提供注册功能</font
            >
          </el-row>
        </div> -->

            <el-row class="register-row">
              <el-col>
                <div style="font-size: 12px">*请填写注册手机和密码</div>
              </el-col>
              <div>
                <el-col class="register-item">
                  <el-col :span="4">
                    <font style="color: red; font-size: 15px">手机号:</font>
                  </el-col>
                  <el-col :span="18">
                    <el-form-item prop="userCode">
                      <el-input
                        prefix-icon="el-icon-user"
                        v-model="registerForm.userCode"
                        placeholder="请输入手机号"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-col>
              </div>
              <div>
                <el-col class="register-item">
                  <el-col :span="4">
                    <font style="color: red; font-size: 15px">密码:</font>
                  </el-col>
                  <el-col :span="18">
                    <el-form-item prop="onePassWord">
                      <el-input type="password"
                        prefix-icon="el-icon-unlock"
                        placeholder="请输入密码"
                        v-model="registerForm.onePassWord"
                        show-onePassWord
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-col>
              </div>
              <div>
                <el-col class="register-item">
                  <el-col :span="4">
                    <font style="color: red; font-size: 15px">确认密码:</font>
                  </el-col>
                  <el-col :span="18">
                    <el-form-item prop="twoPassWord">
                      <el-input type="password"
                        prefix-icon="el-icon-unlock"
                        placeholder="请再次输入密码"
                        v-model="registerForm.twoPassWord"
                        show-onePassWord
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-col>
              </div>
              <el-col>
                <div style="font-size: 12px; margin-top: 5px">
                  *请填写个人信息
                </div>
              </el-col>

              <el-col>
                <div>
                  <el-col class="register-item">
                    <el-col :span="4">
                      <font style="color: red; font-size: 15px">姓名:</font>
                    </el-col>
                    <el-col :span="18">
                      <el-form-item prop="userNameCn">
                        <el-input
                          placeholder="请输入用户名"
                          v-model="registerForm.userNameCn"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-col>
                </div>

                <div>
                  <el-col class="register-item">
                    <el-col :span="4">
                      <font style="color: red; font-size: 15px">身份证:</font>
                    </el-col>
                    <el-col :span="18">
                      <el-form-item prop="identityCardNo">
                        <el-input
                          placeholder="请输入身份证"
                          v-model="registerForm.identityCardNo"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-col>
                </div>

                <div>
                  <el-col class="register-item">
                    <el-col :span="4">
                      <font style="font-size: 15px">所属单位:</font>
                    </el-col>
                    <el-col :span="18">
                      <el-input
                        placeholder="请输入所属单位"
                        v-model="registerForm.remark"
                      ></el-input>
                    </el-col>
                  </el-col>
                </div>

                <div>
                  <el-col class="register-item" style="margin-bottom: 5px">
                    <el-col :span="4">
                      <font style="color: red; font-size: 15px">验证码:</font>
                    </el-col>
                    <el-col :span="18">
                      <el-input
                        type="text"
                        placeholder="请输入图形验证码"
                        v-model="registerForm.code"
                        autocomplete="off"
                      ></el-input>
                    </el-col>
                  </el-col>
                </div>

                <div @click="refreshCode" style="margin: 5px 0 0 70px">
                  <!--验证码组件-->
                  <SIdentify :identifyCode="identifyCode"></SIdentify>
                </div>
              </el-col>
            </el-row>

            <el-row type="flex" justify="center" style="margin-top: 15px">
              <el-col>
                <div style="text-align: center">
                  <el-button type="primary" size="mini" @click="registerComfirm"
                    >确认</el-button
                  >
                  <el-button type="primary" size="mini" @click="cancelComfirm">取消</el-button>
                </div>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
      <el-dialog title="扫描关注公众号" :visible.sync="scanDialogVisible">
          <img :src="imgPath" alt="" style="margin-left: 60px" />
        </el-dialog>
    </div>
  </div>
</template>

<script>
import { getLocation } from "@/api/messageApi";
import { validuserCode } from "@/utils/validate";
import { getweChatToken, getQrCode, getsendIdSuccess } from "@/api/appointment";
import { saveSysUser, whetherRegister } from '@/api/system'
import SIdentify from "@/components/CustomRenderer/identify";
export default {
  name: "register",
  components: {
    SIdentify,
  },
  data() {
    return {
      identifyCodes: "1234567890", // 设置验证码为数字验证码，如果想要验证码为字母数字组合，可以加字母，如： identifyCodes: 'ABCD1234567890abcd'
      identifyCode: "",
      bgImg: require("../../assets/images/login_imgs/login-bg.jpg"),
      logoImg: require("../../assets/images/login_imgs/logo.png"),
      locationIcon: require("../../assets/images/home_imgs/location-icon.png"),
      homeIcon: require("../../assets/images/login_imgs/home-icon.png"),
      loginBgImg: require("../../assets/images/login_imgs/login-context-bg.png"),
      userIcon: require("../../assets/images/login_imgs/user-icon.png"),
      pwdIcon: require("../../assets/images/login_imgs/pwd-icon.png"),
      trueIcon: require("../../assets/images/login_imgs/true-icon.png"),
      locationName: "",
      trueIconVisible: false,
      iconVisible: false,
      isActive: true,
      registerForm: {
        userCode: "",
        onePassWord: "",
        twoPassWord: "",
        userNameCn: "",
        identityCardNo: "",
        remark: "",
        code: "",
      },
      imgPath: "",
      registerRules: {
        userCode: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { min: 11, max: 11, message: "长度为11位", trigger: "blur" },
        ],
        onePassWord: [
          { required: true, message: "请输入密码", trigger: "blur" },
        ],
        twoPassWord: [
          { required: true, message: "请再次输入密码", trigger: "blur" },
        ],
        userNameCn: [
          { required: true, message: "请输入姓名", trigger: "blur" },
        ],
        identityCardNo: [
          { required: true, message: "请输入身份证号码", trigger: "blur" },
          { min: 18, max: 18, message: "长度为18位", trigger: "blur" },
        ],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
      onePassWordType: "onePassWord",
      capsTooltip: false,
      loading: false,
      showDialog: false,
      redirect: undefined,
      otherQuery: {},
      scanDialogVisible: false, //注册扫描弹窗
      isRegisterSuccess: null, //请求是否扫描成功请求定时器
    };
  },
  computed: {},
  watch: {
    $route: {
      handler: function (route) {
        const query = route.query;
        if (query) {
          this.redirect = query.redirect;
          this.otherQuery = this.getOtherQuery(query);
        }
      },
      immediate: true,
    },
    scanDialogVisible: {
      handler: function(newVal) {
        if(!newVal) clearInterval(this.isRegisterSuccess);
      }
    }
  },
  mounted() {
    this.identifyCode = "";
    this.makeCode(this.identifyCodes, 4);
  },
  async created() {

  },
  beforeDestroy() {
    clearInterval(this.isRegisterSuccess);
  },
  methods: {
    cancelComfirm() {
      this.$router.go(-1);
    },
    registerComfirm() {
      for (let key in this.registerForm) {
        if (key !== "remark") {
          if (this.registerForm[key] === "")
            return this.$coreMethods.message("warning", "请填写必填项");
        }
      }
      if (this.registerForm.onePassWord !== this.registerForm.twoPassWord)
        return this.$coreMethods.message("warning", "请输入相同的密码");
      if (this.identifyCode !== this.registerForm.code) {
        this.$coreMethods.message("warning", "请输入正确的验证码");
        this.identifyCode = "";
        this.makeCode(this.identifyCodes, 4);
        return;
      }
      let registerQuestData = JSON.parse(JSON.stringify(this.registerForm));
          whetherRegister(registerQuestData).then(() => {
             getweChatToken().then((res) => {
        console.log(res);
        if (res.success) {

          registerQuestData.accessToken = res.result;
          this.registerQuest(registerQuestData);
        } else {
          this.$coreMethods.message("error", "获取token值失败");
        }
      });
          }).catch((error) => {
            console.log(error)
          })
    },
    //发送注册请求
    registerQuest(registerQuestData) {
      this.$refs.registerForm.validate((valid) => {
        if (valid) {
          getQrCode(registerQuestData)
            .then((res) => {
              if (res.success) {
                this.imgPath =
                  "https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=" +
                  res.result.ticket;
                this.scanDialogVisible = true;
                this.isRegisterSuccess = setInterval(() => {
                  getsendIdSuccess(res.result.sendId).then((res) => {
                    if (res.success) {
                      if (res.result) {
                        clearInterval(this.isRegisterSuccess);
                        this.isRegisterSuccess = null;

                         this.$coreMethods.message("success", "注册成功");
                            setTimeout(function(){
                              this.$router.push({
                            path: "/login",
                          });
                            },1000)
                      }
                    } else {
                      clearInterval(this.isRegisterSuccess);
                      this.isRegisterSuccess = null;

                    }
                  });
                }, 1000);
              } else {
                this.$coreMethods.message("error", "注册失败，请重新注册");
              }
            })
            .catch((error) => {
              const errorObj = JSON.parse(
                error.response.data.header.errorMessage.split("返回内容：")[1]
              );
              this.$coreMethods.message("error", errorObj.errorMessages[0]);
            });
        } else {
          this.$coreMethods.message("error", "内容项填写错误，请重新填写");
        }
      });
    },

    //生成随机数
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    //切换验证码
    refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    // 生成四位随机验证码
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode +=
          this.identifyCodes[this.randomNum(0, this.identifyCodes.length)];
      }
      console.log(this.identifyCode);
    },

    handleLogin() {
      let self = this;
      self.$refs.loginForm.validate((valid) => {
        if (valid) {
          self.loading = true;
          self.$store
            .dispatch("user/login444", self.loginForm)
            .then(() => {
              self.$router.push({
                path: self.redirect || "/",
                query: self.otherQuery,
              });
              self.loading = false;
            })
            .catch(() => {
              self.loading = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    getOtherQuery(query) {
      return Object.keys(query).reduce((acc, cur) => {
        if (cur !== "redirect") {
          acc[cur] = query[cur];
        }
        return acc;
      }, {});
    },
    // 路由跳转
    routeTo(val) {
      this.$router.push(val);
    },
    // 用户名输入框改变事件
    userChange(val) {
      if (this.loginForm.userCode !== "") {
        this.trueIconVisible = true;
      } else {
        this.trueIconVisible = false;
      }
    },
    // 密码输入框改变事件
    pwdChange(val) {
      if (this.loginForm.onePassWord !== "") {
        this.iconVisible = true;
      } else {
        this.iconVisible = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.register-context {
  position: relative;
  width: 100%;
  height: 100%;
  background: url("../../assets/images/register_imgs/background_img.jpg")
    no-repeat;
  background-size: cover;
  .register-title {
    color: #ffffff;
    font-size: 18px;
    font-weight: 1px;
    margin: 0 auto;
    width: 100%;
    height: 50px;
    background-color: #99ccff;
  }

  .register-container {
    display: flex;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 80%;
    height: 80%;
    border-radius: 20px;
    background: url("../../assets/images/register_imgs/register-container.png")
      no-repeat;
    background-size: 120% 100%;
    .register-context-left,
    .register-context-right {
      display: inline-block;
      height: 100%;
    }
    .register-context-right {
      width: 40%;
    }
  }

  .register-context-left {
    width: 60%;
    background: url("../../assets/images/register_imgs/welcome.png") no-repeat;
    background-position: center;
  }

  .register-input {
    width: 100%;
    border: none;
    background-color: transparent;
    color: #000000;
    outline: none;
    margin: 0px 5px;
  }

  .register-icon {
    height: 15px;
    margin-top: 9px;
  }

  .register-btn {
    font-size: 18px;
    padding: 10px;
    width: 100%;
    border-radius: 10px;
    text-align: center;
    background-color: #0e5691;
    color: #000000;
    outline: none;
    border: none;
  }
}

// .el-input {
//   width: 240px;
//   margin-left: 75px;

//   .el-input_inner {
//   }
// }
.register-item {
  display: flex;
  align-items: center;
  margin-top: 8px;
}
</style>
